module.exports = __webpack_public_path__ + "static/media/allRequests.bbebd70e.svg";